import { FormControl, FormField, FormItem } from "@/src/components/ui/form";
import { FiltersFormT } from "./filters.schema";
import { Combobox } from "../../../components/ui/combobox";
import { Input } from "@/src/components/ui/input";

type Hubspot = {
  id: string;
};

export const Hubspot = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full mb-4">Reference number</h3>
      <FormField<FiltersFormT, "hubspot">
        name="hubspot"
        render={({ field }) => {
          return (
            <FormItem>
              <FormControl>
                <Input {...field} placeholder="Enter reference number..." className="w-96" />
              </FormControl>
            </FormItem>
          );
        }}
      />
    </div>
  );
};
